export default {
    namespaced: true,
    actions: {
        getRandomColor(advertiser_number) {
          let colour = '#';
          if (advertiser_number === 0) {
            colour += "3B2CDD";
          }
          else if (advertiser_number === 1) {
            colour += "FF3712";
          }
          else {
            colour += Math.floor(Math.random() * 16777215).toString(16).toUpperCase();
          }
          return colour;
        },
    },
}